import axios from 'axios';

const state = {
  simulationsFilters: {},
  schoolAdmissionSimulationFilters: {},
};

const getters = {
  getSimulationsFilters: state => state.simulationsFilters,
  getSchoolAdmissionSimulationFilters: state => state.schoolAdmissionSimulationFilters,
};

const mutations = {
  updateSimulationsFilters: (state, updatedFilters) => {
    state.simulationsFilters = { ...state.simulationsFilters, ...updatedFilters };
  },
  updateSchoolAdmissionSimulationFilters: (state, updatedFilters) => {
    state.schoolAdmissionSimulationFilters = { ...state.schoolAdmissionSimulationFilters, ...updatedFilters };
  },
};

const actions = {
  async getAllSimulations(_obj, params) {
    const res = await axios.get(`api/simulations/`, { params });
    return res.data;
  },

  async getEntitySimulations(_obj, params) {
    const res = await axios.get(`api/simulations/entity-simulations/`, { params });
    return res.data;
  },

  // Interview simulations posted by the org(s) the logged-in student belongs to.
  async getStudentInterviews(_obj, params) {
    const res = await axios.get(`api/simulations/student-interviews/`, { params });
    return res.data;
  },
  // School-scenario interviews selectable inside a scenario assignment.
  async getSchoolScenarios(_obj, params) {
    const res = await axios.get(`api/simulations/school-scenarios/`, { params });
    return res.data;
  },
  async getSchoolAdmissionSimulations(_obj, params) {
    const res = await axios.get('api/simulations/all-school-admissions/', { params });
    return res.data;
  },
  async getSimulation(_obj, id) {
    const res = await axios.get(`api/simulations/${id}/`);
    return res.data;
  },

  async getSimulationFromSlug(_obj, params) {
    const res = await axios.get(`api/simulations/from-slug/`, { params });
    return res.data;
  },

  async createSimulationFeedback(_obj, data) {
    return await axios.post(`api/simulations/call-logs/submit-feedback/`, data);
  },
  async createSimulation(_obj, data) {
    return axios.post(`api/simulations/`, data);
  },

  // Anam's voice catalogue, proxied by our backend (the API key is server-side).
  async getAnamVoices() {
    const res = await axios.get(`api/simulations/anam-voices/`);
    return res.data;
  },

  // Anam's avatar catalogue, proxied for the same reason as the voices.
  async getAnamAvatars() {
    const res = await axios.get(`api/simulations/anam-avatars/`);
    return res.data;
  },

  // Anam's model catalogue, proxied for the same reason as the voices.
  async getAnamLlms() {
    const res = await axios.get(`api/simulations/anam-llms/`);
    return res.data;
  },

  async registerSimulation(_obj, data) {
    return axios.post(`api/simulations/register-simulation/`, data);
  },

  // Anam has no webhook, so the browser tells the backend the moment the SDK
  // reports the session closed. Grading starts from here.
  async anamSessionEnded(_obj, data) {
    return axios.post(`api/simulations/call-logs/anam/session-ended/`, data);
  },

  async updateSimulation(_obj, { id, data }) {
    return axios.patch(`api/simulations/${id}/`, data);
  },

  async updateSimulationStatus(_obj, { id, data }) {
    return axios.patch(`api/simulations/${id}/update-is-active/`, data);
  },

  async deleteSimulation(_obj, id) {
    return axios.delete(`api/simulations/${id}/`);
  },

  async getSimulationImageUploadPresignedUrl(_obj, data) {
    return (await axios.post(`api/simulations/upload-url/`, data)).data.data;
  },

  async getSimulationsSubmissions(_obj, params) {
    const res = await axios.get(`api/simulations/call-logs/`, { params });
    return res.data;
  },

  async getSimulationSubmission(_obj, id) {
    const res = await axios.get(`api/simulations/call-logs/${id}/`);
    return res.data;
  },

  async getAiCallLogs(_obj, params) {
    const res = await axios.get(`api/simulations/ai-call-logs/`, { params });
    return res.data;
  },

  async getAiCallLog(_obj, id) {
    const res = await axios.get(`api/simulations/ai-call-logs/${id}/`);
    return res.data;
  },

  async updateSimulationsFilters({ commit }, { filters }) {
    commit('updateSimulationsFilters', filters);
  },
  async updateSchoolAdmissionSimulationFilters({ commit }, { filters }) {
    commit('updateSchoolAdmissionSimulationFilters', filters);
  },
};

export const simulations = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
